import { cloneDeep } from 'lodash';

import { type IBillingAddress } from 'src/graphql/schema';
import { BillingDocument } from 'src/graphql/actions/billing/billing.query';

import { apolloClient as client } from '../apollo-client';

import type { IBillingQuery } from 'src/graphql/actions/billing/billing.query';

export const updateBillingAddressCache = (data: IBillingAddress) => {
  const cacheData = cloneDeep(
    client.readQuery<IBillingQuery>({
      query: BillingDocument,
    }),
  );

  if (!cacheData?.billing) return;

  client.writeQuery({
    query: BillingDocument,
    data: {
      billing: {
        ...cacheData.billing,
        billingAddress: data,
      },
    },
  });
};
